(function() {
	const root = document.querySelector('[data-after-booking]');

	if (!root) {
		return;
	}

	const apiUrl = window.AFTER_BOOKING_API_URL;

	const menuEl = root.querySelector('[data-booking-menu]');
	const dateEl = root.querySelector('[data-booking-date]');
	const slotEl = root.querySelector('[data-booking-slot]');
	const nameEl = root.querySelector('[data-booking-name]');
	const emailEl = root.querySelector('[data-booking-email]');
	const phoneEl = root.querySelector('[data-booking-phone]');
	const noteEl = root.querySelector('[data-booking-note]');
	const submitEl = root.querySelector('[data-booking-submit]');
	const messageEl = root.querySelector('[data-booking-message]');

	const defaultTimes = [
		'12:00',
		'13:15',
		'14:30',
		'15:45',
		'17:00',
		'18:15'
	];

	// Localised strings injected from Liquid (window.AFTER_BOOKING_I18N), with
	// Japanese fallbacks so the widget still works if injection is missing.
	const i18nDefaults = {
		locale: 'ja',
		menu: { glasses: '眼鏡', watch: '時計', both: '眼鏡と時計' },
		submit: '予約する',
		submitting: '送信中...',
		nameSuffix: '様',
		timeSuffix: '〜',
		timeZoneSuffix: '',
		calendarTitle: 'AFTER 来店予約',
		location: 'AFTER, 1-29-6 Aobadai, Meguro, Tokyo',
		detailsContent: '内容：',
		rows: { menu: '内容', date: '日付', time: '時間', name: 'お名前', email: 'メールアドレス', phone: '電話番号', note: '備考' },
		messages: {
			noUrl: '予約システムのURLが設定されていません。',
			selectInterest: '先にご希望内容を選択してください。',
			noDays: '予約可能日がありません。',
			noMonth: '表示する月がありません。',
			loadDaysFailed: '予約可能日の読み込みに失敗しました。',
			slotsFailed: '時間枠の取得に失敗しました。',
			booked: '予約リクエストを受け付けました。',
			bookFailed: '予約に失敗しました。時間をおいて再度お試しください。'
		},
		errors: {
			needInterest: 'ご希望内容を選択してください。',
			needDate: '日付を選択してください。',
			needTime: '時間を選択してください。',
			needName: 'お名前を入力してください。',
			needEmail: 'メールアドレスを入力してください。',
			badEmail: 'メールアドレスの形式を確認してください。'
		}
	};
	const i18n = Object.assign({}, i18nDefaults, window.AFTER_BOOKING_I18N || {});
	const menuLabels = i18n.menu;

	const bookingMinutes = 60;

	let summary = [];
	let currentSlots = [];
	let selectedDate = '';
	let selectedSlot = null;
	let currentCalendarMonth = '';
	let calendarTitleEl = null;
	let calendarGridEl = null;
	let calendarPrevEl = null;
	let calendarNextEl = null;
	let timesEl = null;
	let menuStepField = null;
	let dateStepField = null;
	let timeStepField = null;
	let infoStepField = null;
	let menuInteracted = false;
	let popupEl = null;
	let popupDetailsEl = null;
	let calendarLinkEl = null;

	// Styling lives in the section's {% stylesheet %} (after-booking.liquid);
	// the JS no longer injects its own <style> so the theme design governs.
	setupCustomDateTimeUI();
	setupPopupUI();

	function setupCustomDateTimeUI() {
		// The calendar/time markup lives in the section; just wire up references.
		calendarTitleEl = root.querySelector('[data-booking-calendar-title]');
		calendarGridEl = root.querySelector('[data-booking-calendar-grid]');
		calendarPrevEl = root.querySelector('[data-booking-calendar-prev]');
		calendarNextEl = root.querySelector('[data-booking-calendar-next]');
		timesEl = root.querySelector('[data-booking-times]');

		menuStepField = menuEl ? menuEl.closest('.after-booking__field') : null;
		dateStepField = calendarGridEl ? calendarGridEl.closest('.after-booking__field') : null;
		timeStepField = timesEl ? timesEl.closest('.after-booking__field') : null;
		infoStepField = root.querySelector('[data-booking-info-field]');

		if (calendarPrevEl) {
			calendarPrevEl.addEventListener('click', function() {
				moveCalendarMonth(-1);
			});
		}

		if (calendarNextEl) {
			calendarNextEl.addEventListener('click', function() {
				moveCalendarMonth(1);
			});
		}

		updateActiveStep();
	}

	// Highlight the next step the visitor should act on. The menu always has a
	// default value, so the first actionable step is the date, then the time.
	function updateActiveStep() {
		[menuStepField, dateStepField, timeStepField, infoStepField].forEach(function(field) {
			if (field) {
				field.classList.remove('is-next');
			}
		});

		// Step 1 (menu) leads until the visitor confirms a choice; then date,
		// then time, then customer info. Picking a date directly also advances
		// past the menu.
		let nextField = null;

		if (!menuInteracted && !selectedDate) {
			nextField = menuStepField;
		} else if (!selectedDate) {
			nextField = dateStepField;
		} else if (!selectedSlot) {
			nextField = timeStepField;
		} else {
			nextField = infoStepField;
		}

		if (nextField) {
			nextField.classList.add('is-next');
		}
	}

	function setupPopupUI() {
		popupEl = root.querySelector('[data-booking-popup]');

		if (!popupEl) {
			return;
		}

		popupDetailsEl = root.querySelector('[data-booking-popup-details]');
		calendarLinkEl = root.querySelector('[data-booking-calendar-link]');

		root.querySelectorAll('[data-booking-popup-close]').forEach(function(closeEl) {
			closeEl.addEventListener('click', function() {
				closeBookingCompletePopup();
			});
		});

		document.addEventListener('keydown', function(event) {
			if (event.key === 'Escape') {
				closeBookingCompletePopup();
			}
		});
	}

	function setMessage(message, isError) {
		messageEl.textContent = message || '';
		messageEl.style.color = isError ? '#b00020' : '';
	}

	function setLoading(isLoading) {
		submitEl.disabled = isLoading;
		submitEl.textContent = isLoading ? i18n.submitting : i18n.submit;
	}

	function requestGet(params) {
		const url = new URL(apiUrl);

		Object.keys(params).forEach(function(key) {
			url.searchParams.set(key, params[key]);
		});

		return fetch(url.toString(), {
			method: 'GET'
		}).then(function(response) {
			return response.json();
		});
	}

	function requestPost(payload) {
		return fetch(apiUrl, {
			method: 'POST',
			headers: {
				'Content-Type': 'text/plain;charset=utf-8'
			},
			body: JSON.stringify(payload)
		}).then(function(response) {
			return response.json();
		});
	}

	function loadSummary() {
		if (!apiUrl) {
			setMessage(i18n.messages.noUrl, true);
			renderInitialCalendarMessage(i18n.messages.noUrl);
			return;
		}

		selectedDate = '';
		selectedSlot = null;
		currentSlots = [];

		// Show the current month grayed out immediately, with a spinner on the
		// date step, while the available days load.
		currentCalendarMonth = getMonthKey(formatLocalDate(new Date()));
		renderCalendarMonth(menuEl.value);
		setDateLoading(true);
		renderTimes(null);

		requestGet({
			action: 'summary'
		}).then(function(result) {
			if (!result.ok) {
				throw new Error(result.message || i18n.messages.loadDaysFailed);
			}

			summary = normalizeListResult(result);
			setMessage('', false);
			setDateLoading(false);

			if (menuEl.value) {
				renderDates(menuEl.value);
			} else {
				renderInitialCalendarMessage(i18n.messages.selectInterest);
				renderTimes(null);
			}
		}).catch(function(error) {
			setDateLoading(false);
			setMessage(error.message || i18n.messages.loadDaysFailed, true);
			renderInitialCalendarMessage(i18n.messages.loadDaysFailed);
			renderTimes(null);
		});
	}

	function setDateLoading(isLoading) {
		if (dateStepField) {
			dateStepField.classList.toggle('is-loading', isLoading);
		}
	}

	function normalizeListResult(result) {
		if (Array.isArray(result.data)) {
			return result.data;
		}

		if (result.data && Array.isArray(result.data.days)) {
			return result.data.days;
		}

		if (result.data && Array.isArray(result.data.slots)) {
			return result.data.slots;
		}

		if (Array.isArray(result.days)) {
			return result.days;
		}

		if (Array.isArray(result.slots)) {
			return result.slots;
		}

		return [];
	}

	function renderInitialCalendarMessage(message) {
		if (!calendarTitleEl || !calendarGridEl) {
			return;
		}

		calendarTitleEl.textContent = '';
		calendarGridEl.innerHTML = '<p class="after-booking-calendar__empty">' + escapeHtml(message) + '</p>';
	}

	function renderDates(menu) {
		selectedDate = '';
		selectedSlot = null;
		currentSlots = [];
		renderTimes(null);
		updateActiveStep();

		if (!menu) {
			renderInitialCalendarMessage(i18n.messages.selectInterest);
			return;
		}

		if (!summary.length) {
			renderInitialCalendarMessage(i18n.messages.noDays);
			return;
		}

		const firstAvailableDay = summary.find(function(day) {
			return isDateSelectableForMenu(day, menu);
		});

		const firstDay = firstAvailableDay || summary[0];
		currentCalendarMonth = getMonthKey(firstDay.date);

		renderCalendarMonth(menu);
	}

	function isDateSelectableForMenu(day, menu) {
		if (!day || !day.date) {
			return false;
		}

		if (day.status === 'closed' || day.status === 'full') {
			return false;
		}

		if (day.available === false || day.isAvailable === false) {
			return false;
		}

		if (menu === 'glasses') {
			return day.status === 'glasses_only' || day.status === 'glasses_watch' || day.status === 'available' || day.status === 'open' || day.available === true || day.isAvailable === true;
		}

		if (menu === 'watch' || menu === 'both') {
			return day.status === 'glasses_watch' || day.status === 'available' || day.status === 'open' || day.available === true || day.isAvailable === true;
		}

		return false;
	}

	function renderCalendarMonth(menu) {
		if (!currentCalendarMonth) {
			renderInitialCalendarMessage(i18n.messages.noMonth);
			return;
		}

		const monthDate = parseMonthKey(currentCalendarMonth);
		const year = monthDate.getFullYear();
		const month = monthDate.getMonth();

		calendarTitleEl.textContent = formatMonthTitle(year, month);
		calendarGridEl.innerHTML = '';

		const firstDate = new Date(year, month, 1, 12, 0, 0);
		const lastDate = new Date(year, month + 1, 0, 12, 0, 0);
		const firstWeekday = firstDate.getDay();
		const daysInMonth = lastDate.getDate();

		for (let dayNumber = 1; dayNumber <= daysInMonth; dayNumber++) {
			const date = new Date(year, month, dayNumber, 12, 0, 0);
			const dateString = formatLocalDate(date);
			const dayData = findSummaryDay(dateString);
			const selectable = dayData && isDateSelectableForMenu(dayData, menu);

			const button = document.createElement('button');
			button.type = 'button';
			button.className = 'after-booking-calendar__day';
			button.textContent = String(dayNumber);
			button.dataset.date = dateString;

			if (dayNumber === 1) {
				button.style.gridColumnStart = String(firstWeekday + 1);
			}

			if (!selectable) {
				button.disabled = true;
				button.classList.add('is-disabled');
			}

			if (selectedDate === dateString) {
				button.classList.add('is-selected');
			}

			button.addEventListener('click', function() {
				selectedDate = dateString;
				selectedSlot = null;

				if (dateEl) {
					dateEl.value = selectedDate;
				}

				renderCalendarMonth(menu);
				loadSlots();
				updateActiveStep();
			});

			calendarGridEl.appendChild(button);
		}
	}

	function findSummaryDay(dateString) {
		return summary.find(function(item) {
			return item.date === dateString;
		});
	}

	function moveCalendarMonth(amount) {
		if (!currentCalendarMonth) {
			return;
		}

		const date = parseMonthKey(currentCalendarMonth);
		date.setMonth(date.getMonth() + amount);
		currentCalendarMonth = date.getFullYear() + '-' + String(date.getMonth() + 1).padStart(2, '0');

		renderCalendarMonth(menuEl.value);
	}

	function loadSlots() {
		const menu = menuEl.value;

		if (!menu || !selectedDate) {
			renderTimes(null);
			return;
		}

		renderTimes(null, { loading: true });

		requestGet({
			action: 'slots',
			menu: menu,
			date: selectedDate
		}).then(function(result) {
			if (!result.ok) {
				throw new Error(result.message || i18n.messages.slotsFailed);
			}

			currentSlots = normalizeListResult(result);
			renderTimes(currentSlots);
		}).catch(function(error) {
			setMessage(error.message || i18n.messages.slotsFailed, true);
			currentSlots = [];
			renderTimes([]);
		});
	}

	function renderTimes(availableSlots, options) {
		options = options || {};

		if (!timesEl) {
			return;
		}

		const isLoading = !!options.loading;

		timesEl.innerHTML = '';

		// Loading spinner shows next to the "時間を選択" label (on its field).
		if (timeStepField) {
			timeStepField.classList.toggle('is-loading', isLoading);
		}

		// Always render every slot as a pill. Pills with no matching available
		// slot stay grayed out (disabled); they become active once a date is
		// selected and its open slots load.
		defaultTimes.forEach(function(time) {
			const matchedSlot = (!isLoading && Array.isArray(availableSlots)) ? availableSlots.find(function(slot) {
				return normalizeTime(slot.time || slot.label) === normalizeTime(time);
			}) : null;

			const button = document.createElement('button');
			button.type = 'button';
			button.className = 'after-booking-times__button';
			button.textContent = time + i18n.timeZoneSuffix;

			if (!matchedSlot) {
				button.disabled = true;
				button.classList.add('is-disabled');
			} else {
				button.addEventListener('click', function() {
					selectedSlot = matchedSlot;

					if (slotEl) {
						slotEl.value = time;
					}

					renderTimes(availableSlots);
					updateActiveStep();
				});
			}

			if (selectedSlot && normalizeTime(selectedSlot.time || selectedSlot.label) === normalizeTime(time)) {
				button.classList.add('is-selected');
			}

			timesEl.appendChild(button);
		});
	}

	function normalizeTime(value) {
		return String(value || '').trim().replace(/^0/, '');
	}

	function validateForm() {
		if (!menuEl.value) {
			return i18n.errors.needInterest;
		}

		if (!selectedDate) {
			return i18n.errors.needDate;
		}

		if (!selectedSlot) {
			return i18n.errors.needTime;
		}

		if (!nameEl.value.trim()) {
			return i18n.errors.needName;
		}

		if (!emailEl.value.trim()) {
			return i18n.errors.needEmail;
		}

		if (!/^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(emailEl.value.trim())) {
			return i18n.errors.badEmail;
		}

		return '';
	}

	function submitBooking() {
		const validationMessage = validateForm();

		if (validationMessage) {
			setMessage(validationMessage, true);
			return;
		}

		const booking = {
			menu: menuEl.value,
			date: selectedSlot.date || selectedDate,
			time: selectedSlot.time || selectedSlot.label,
			staff: selectedSlot.staff,
			name: nameEl.value.trim(),
			email: emailEl.value.trim(),
			phone: phoneEl.value.trim(),
			note: noteEl.value.trim(),
			// Page locale ('ja' / 'en'...) so the backend can send the customer's
			// confirmation email in their language. Admin mail stays Japanese.
			locale: i18n.locale
		};

		setLoading(true);
		setMessage('', false);

		requestPost({
			action: 'book',
			booking: booking
		}).then(function(result) {
			if (!result.ok) {
				throw new Error(result.message || i18n.messages.bookFailed);
			}

			setMessage(i18n.messages.booked, false);

			// GAS confirms the booking but doesn't echo its details, so build the
			// confirmation popup from what we just submitted.
			const start = new Date(booking.date + 'T' + booking.time + ':00+09:00');
			const end = new Date(start.getTime() + bookingMinutes * 60 * 1000);
			const menuLabel = menuLabels[booking.menu] || booking.menu;

			showBookingCompletePopup({
				menu: menuLabel,
				date: formatBookingDate(start),
				time: booking.time + i18n.timeSuffix,
				name: booking.name,
				email: booking.email,
				phone: booking.phone,
				note: booking.note,
				start: start,
				end: end,
				calendarTitle: i18n.calendarTitle,
				calendarDetails: i18n.detailsContent + menuLabel,
				location: i18n.location
			});

			nameEl.value = '';
			emailEl.value = '';
			phoneEl.value = '';
			noteEl.value = '';

			loadSummary();
		}).catch(function(error) {
			setMessage(error.message || i18n.messages.bookFailed, true);
		}).finally(function() {
			setLoading(false);
		});
	}

	function showBookingCompletePopup(booking) {
		if (!popupEl || !popupDetailsEl || !calendarLinkEl) {
			return;
		}

		popupDetailsEl.innerHTML = '';

		appendDetailRow(i18n.rows.menu, booking.menu);
		appendDetailRow(i18n.rows.date, booking.date);
		appendDetailRow(i18n.rows.time, booking.time);
		appendDetailRow(i18n.rows.name, booking.name ? booking.name + i18n.nameSuffix : '');
		appendDetailRow(i18n.rows.email, booking.email);
		appendDetailRow(i18n.rows.phone, booking.phone);
		appendDetailRow(i18n.rows.note, booking.note);

		// Hand the device's default calendar app an .ics file.
		calendarLinkEl.href = buildIcsDataUri(booking);
		calendarLinkEl.setAttribute('download', 'after-booking.ics');

		popupEl.classList.add('is-open');
		popupEl.setAttribute('aria-hidden', 'false');
		document.documentElement.style.overflow = 'hidden';
	}

	function appendDetailRow(label, value) {
		if (!value) {
			return;
		}

		const row = document.createElement('div');
		row.className = 'after-booking-popup__row';

		const dt = document.createElement('dt');
		dt.textContent = label;

		const dd = document.createElement('dd');
		dd.textContent = value;

		row.appendChild(dt);
		row.appendChild(dd);
		popupDetailsEl.appendChild(row);
	}

	function closeBookingCompletePopup() {
		if (!popupEl) {
			return;
		}

		popupEl.classList.remove('is-open');
		popupEl.setAttribute('aria-hidden', 'true');
		document.documentElement.style.overflow = '';
	}

	function buildIcsDataUri(booking) {
		// Anchor the event to Asia/Tokyo so it always shows as JST wall-clock
		// (e.g. 18:15) and stays correct in any device timezone.
		const dtStart = formatIcsJst(new Date(booking.start));
		const dtEnd = formatIcsJst(new Date(booking.end));
		const stamp = formatIcsUtc(new Date());
		const uid = 'after-' + Date.now() + '@after.llc';

		const lines = [
			'BEGIN:VCALENDAR',
			'VERSION:2.0',
			'PRODID:-//AFTER//Booking//EN',
			'CALSCALE:GREGORIAN',
			'BEGIN:VTIMEZONE',
			'TZID:Asia/Tokyo',
			'BEGIN:STANDARD',
			'DTSTART:19700101T000000',
			'TZOFFSETFROM:+0900',
			'TZOFFSETTO:+0900',
			'TZNAME:JST',
			'END:STANDARD',
			'END:VTIMEZONE',
			'BEGIN:VEVENT',
			'UID:' + uid,
			'DTSTAMP:' + stamp,
			'DTSTART;TZID=Asia/Tokyo:' + dtStart,
			'DTEND;TZID=Asia/Tokyo:' + dtEnd,
			'SUMMARY:' + escapeIcsText(booking.calendarTitle || 'AFTER store visit'),
			'DESCRIPTION:' + escapeIcsText(booking.calendarDetails || ''),
			'LOCATION:' + escapeIcsText(booking.location || 'AFTER, 1-29-6 Aobadai, Meguro, Tokyo'),
			'END:VEVENT',
			'END:VCALENDAR'
		];

		return 'data:text/calendar;charset=utf-8,' + encodeURIComponent(lines.join('\r\n'));
	}

	function formatIcsUtc(date) {
		return date.toISOString().replace(/[-:]/g, '').replace(/\.\d{3}/, '');
	}

	// "YYYYMMDDTHHMMSS" in Asia/Tokyo wall-clock (no Z), paired with TZID.
	function formatIcsJst(date) {
		const parts = new Intl.DateTimeFormat('en-CA', {
			timeZone: 'Asia/Tokyo',
			year: 'numeric',
			month: '2-digit',
			day: '2-digit',
			hour: '2-digit',
			minute: '2-digit',
			second: '2-digit',
			hour12: false
		}).formatToParts(date);

		const p = {};
		parts.forEach(function(part) {
			p[part.type] = part.value;
		});

		const hour = p.hour === '24' ? '00' : p.hour;

		return p.year + p.month + p.day + 'T' + hour + p.minute + p.second;
	}

	function escapeIcsText(value) {
		return String(value || '')
			.replace(/\\/g, '\\\\')
			.replace(/;/g, '\\;')
			.replace(/,/g, '\\,')
			.replace(/\n/g, '\\n');
	}

	function getMonthKey(dateString) {
		return String(dateString || '').slice(0, 7);
	}

	function parseMonthKey(monthKey) {
		const parts = String(monthKey || '').split('-');
		return new Date(Number(parts[0]), Number(parts[1]) - 1, 1, 12, 0, 0);
	}

	function formatLocalDate(date) {
		const year = date.getFullYear();
		const month = String(date.getMonth() + 1).padStart(2, '0');
		const day = String(date.getDate()).padStart(2, '0');

		return year + '-' + month + '-' + day;
	}

	// Calendar header ("2026年6月" / "June 2026"), locale-aware.
	function formatMonthTitle(year, month) {
		try {
			return new Intl.DateTimeFormat(i18n.locale, {
				year: 'numeric',
				month: 'long'
			}).format(new Date(year, month, 1));
		} catch (error) {
			return year + '-' + String(month + 1).padStart(2, '0');
		}
	}

	// Popup date ("2026年6月24日" / "June 24, 2026"), kept in JST.
	function formatBookingDate(date) {
		try {
			return new Intl.DateTimeFormat(i18n.locale, {
				year: 'numeric',
				month: 'long',
				day: 'numeric',
				timeZone: 'Asia/Tokyo'
			}).format(date);
		} catch (error) {
			return formatLocalDate(date);
		}
	}

	function escapeHtml(value) {
		return String(value || '')
			.replace(/&/g, '&amp;')
			.replace(/</g, '&lt;')
			.replace(/>/g, '&gt;')
			.replace(/"/g, '&quot;')
			.replace(/'/g, '&#039;');
	}

	setupMenuChoices();

	function setupMenuChoices() {
		const choices = root.querySelectorAll('[data-booking-menu-option]');

		choices.forEach(function(choice) {
			choice.addEventListener('click', function() {
				choices.forEach(function(other) {
					other.classList.remove('is-selected');
				});

				choice.classList.add('is-selected');
				menuEl.value = choice.dataset.bookingMenuOption;
				menuInteracted = true;

				renderDates(menuEl.value);
			});
		});
	}

	submitEl.addEventListener('click', function() {
		submitBooking();
	});

	loadSummary();
})();
